import { createService, getPaginatedResponseSchema } from '@betty/toolkit/api';
import {
  OptInSchema,
  OptOutSchema,
  PromotionSchema,
} from './PromosService.schemas';
import { DepositPromo } from '../../state/deposit/deposit.types';

const PromosService = createService(
  {
    getPromos: {
      url: '/promotions',
      method: 'GET',
      responseSchema: getPaginatedResponseSchema(PromotionSchema),
    },
    optIn: {
      url: ({ promoId }: { promoId: DepositPromo['promotionId'] }) =>
        `/promotions/${promoId}/optin`,
      method: 'POST',
      responseSchema: OptInSchema,
    },
    optOut: {
      url: ({ promoId }: { promoId: DepositPromo['promotionId'] }) =>
        `/promotions/${promoId}/optout`,
      method: 'POST',
      responseSchema: OptOutSchema,
    },
  },
  ({ userId }) => `/Players/${userId}`,
);

export default PromosService;
